<template>
  <div style="background-color: #f6f6f6">
    <van-nav-bar
      title="亿起抢"
      right-text="关注"
      @click-right="onClickRight"
      fixed
    />
    <div style="height: 46px"></div>
    <van-list
      class="goodsList"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <router-link
        :to="'/qiang/detail/' + item.id"
        class="item"
        v-for="item in goodsList"
        :key="item.id"
      >
        <van-tag
          class="huodongTag"
          v-if="item.goods_level == 1"
          mark
          type="danger"
          >活动</van-tag
        >
        <van-image
          class="thumbnail"
          width="100%"
          height="60vw"
          fit="cover"
          radius="10px"
          :src="GLOBAL.IMG + item.thumbnail"
        />
        <div class="title">{{ item.post_title }}</div>
        <div class="price">
          <span style="color: #F40; font-size: 16px; font-weight: 900"
            >¥{{ item.price }}</span
          >
          <span style="text-decoration: line-through; font-size: 12px"
            >¥{{ item.yprice }}</span>
            <span >热度 {{ item.post_hits }}</span>
        </div>
        <div style="padding: 2px 0 6px 8px" v-if="item.share_sub_money != '0.00'&&user.user.is_share==1">
          <van-button icon="share" round size="mini" type="warning">群主返：{{ item.share_sub_money }} 分享师返：{{item.share_money}} </van-button>
        </div>
        <div class="timer">
          <van-count-down
            :time="item.end_time * 1000 - Date.parse(new Date())"
            format="DD天HH时mm分ss秒"
          />
        </div>
      </router-link>
    </van-list>
    <div style="height: 46px"></div>
    <TabBar active="2" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import Vue from "vue";
import { CountDown } from "vant";
import wx_share from "../../common/wx_share.js";
Vue.use(CountDown);
export default {
  name: "qiangList",
  components: {
    TabBar,
  },
  data() {
    return {
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1,
      user: { token: "", user: { id: 0 ,is_share:0} },
    };
  },
  methods: {
    onClickRight() {
      this.$router.push("/article/detail/71");
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_qiang/goods/goodsList", {
          params: { cid: 1, page: this.cPage },
          headers: { "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    },
  },
  mounted() {
    window.CateListScrollTop = 0;
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    let item = {
      post_title: "亿家一家亿起抢栏目",
      //desc: "亿家一家亿起抢商品列表，关注公众号，会有意外惊喜呦。",
      desc: "亿家一家亿起抢所有商品买三单免一单，一起把福利抱回家啦！",
      thumbnail: "http://yijia.sihandbms.cn/upload/default/logo.jpg",
    };
    wx_share.wx_share(this.GLOBAL.API, this.user, item);
  },
  beforeRouteLeave(to, from, next) {
    //离开该页面的时候把高度记录
    window.CateListScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  activated() {
    //返回的时候滚动到记录的高度
    //延时200ms，不延迟滚动的话，有商品页内容高度比较小的情况就返不回原来的位置
    setTimeout(() => {
      window.scrollTo(0, window.CateListScrollTop);
    }, 200);
  },
};
</script>
<style lang="scss" scoped>
.goodsList {
  text-align: left;
  .item {
    position: relative;
    background-color: #fff;
    display: block;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
    border-radius: 20px;
    .huodongTag {
      position: absolute;
      z-index: 999;
      top: 0;
      left: 0;
    }
    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 0 5px;
      color: #222333;
    }
    .price {
      text-align: left;
      padding: 6px 5px 6px 5px;
      line-height: 20px;
      span{
          padding-left:10px;
      }
    }
    .timer {
      position: absolute;
      right: 10px;
      top: 10px;
      background-color: #1baeae;
      padding: 5px 20px 5px 20px;
      .van-count-down {
        color: #f9f9f9;
        font-weight: 500;
      }
      border-radius:10px;
    }
  }
  .van-button{padding: 0 10px !important;}
  .van-button--warning { border: none;}
}
</style>